// This file is auto-generated by @hey-api/openapi-ts

export type Body_resend_activation_email_users__user_uuid__resend_activation_email_post = {
    performed_by_user_uuid?: string | null;
};

export type Body_reset_password_users__user_uuid__reset_password_post = {
    performed_by_user_uuid?: string | null;
};

export type Body_send_activation_email_users__user_uuid__send_activation_email_post = {
    performed_by_user_uuid?: string | null;
};

/**
 * The parameters a caller can use to create a new Tenant.
 */
export type CreateTenant = {
    tenantName: string;
    domains: Array<(string)>;
    tenantTypes: Array<(string)>;
    tools: Array<(string)>;
    providerMetadata: ProviderMetadataModel | null;
    requesterMetadata: RequesterMetadataModel | null;
};

/**
 * The parameters a caller can use to create a new User.
 */
export type CreateUser = {
    firstName: string;
    lastName: string;
    emailAddress: string;
    password?: string | null;
    phoneNumber: string;
    tenantId: number;
    isAdmin: boolean;
    createUserInOkta: boolean;
    addUserToRmGroup?: boolean | null;
    oktaGroups?: Array<(string)> | null;
    addToProductInternalGroup?: boolean | null;
};

/**
 * The parameters a caller can use to create new Users.
 */
export type CreateUsers = {
    users: Array<CreateUser>;
};

/**
 * Pydantic Model of a DigitalMetadata with eligibility object.
 */
export type DigitalMetadataWithEligibility = {
    /**
     * The digital site id of the provider.
     */
    digitalSiteId: number | null;
    /**
     * The fulfillment method of the provider.
     */
    fulfillmentMethod: string | null;
    /**
     * The tenant id of the provider.
     */
    tenantId: number;
    /**
     * Whether the provider is live for digital fulfillment.
     */
    isLiveDigitalFulfillment: boolean;
    /**
     * The EMR name for the provider.
     */
    emr?: string | null;
    /**
     * The EMR environment for the provider.
     */
    emrEnvironment?: string | null;
    /**
     * The DF onboarding status of the provider.
     */
    onboardingStatus?: DigitalOnboardingStatus | null;
    /**
     * Whether the address feedback has been completed.
     */
    addressFeedbackComplete: boolean | null;
    /**
     * The go live date of the provider.
     */
    goLiveDate: string | null;
    /**
     * If EMR / environment combination is eligible for digital fulfillment
     */
    eligibility: boolean | null;
    /**
     * If EMR / environment combination is eligible for self serve onboarding for digital fulfillment
     */
    selfServeEligibility: boolean | null;
    /**
     * The EMR config id for the provider. This is used to determine which tracker to show in the UI.
     */
    emrConfigId: string | null;
};

export type DigitalOnboardingStatus = 'EMR_SUBMITTED' | 'DOCUSIGN_COMPLETED' | 'CREDENTIALS_SUBMITTED' | 'CREDENTIALS_TEST_SUCCESSFUL' | 'CREDENTIALS_TEST_FAILED' | 'BACKLOAD_COMPLETED' | 'ENCOUNTER_FEEDBACK_COMPLETED' | 'SCANNED_DOCUMENT_FEEDBACK_COMPLETED' | 'QC_STARTED' | 'QC_READY' | 'QC_COMPLETED' | 'QC_FAILED' | 'INSTALLED';

export const DigitalOnboardingStatus = {
    EMR_SUBMITTED: 'EMR_SUBMITTED',
    DOCUSIGN_COMPLETED: 'DOCUSIGN_COMPLETED',
    CREDENTIALS_SUBMITTED: 'CREDENTIALS_SUBMITTED',
    CREDENTIALS_TEST_SUCCESSFUL: 'CREDENTIALS_TEST_SUCCESSFUL',
    CREDENTIALS_TEST_FAILED: 'CREDENTIALS_TEST_FAILED',
    BACKLOAD_COMPLETED: 'BACKLOAD_COMPLETED',
    ENCOUNTER_FEEDBACK_COMPLETED: 'ENCOUNTER_FEEDBACK_COMPLETED',
    SCANNED_DOCUMENT_FEEDBACK_COMPLETED: 'SCANNED_DOCUMENT_FEEDBACK_COMPLETED',
    QC_STARTED: 'QC_STARTED',
    QC_READY: 'QC_READY',
    QC_COMPLETED: 'QC_COMPLETED',
    QC_FAILED: 'QC_FAILED',
    INSTALLED: 'INSTALLED'
} as const;

/**
 * Pydantic Model of a Eligibility object.
 */
export type EligibilityBase = {
    /**
     * The name of the emr
     */
    emrName: string | null;
    /**
     * The method of the emr
     */
    emrMethod: EmrMethod | null;
    /**
     * The environment of the emr
     */
    emrEnvironment: EmrEnvironment | null;
    /**
     * Whether the emr / env combo is eligible for digital fulfillment.
     */
    isEligible: boolean;
    /**
     * If EMR / environment combination is eligible for self serve onboarding for digital fulfillment
     */
    selfServeEligibility: boolean;
    /**
     * The id of the EMR config to be used to render the correct tracker in the UI.
     */
    emrConfigId: string | null;
};

export type EmrEnvironment = 'CLOUD' | 'ON_PREMISE' | 'NOT_SURE';

export const EmrEnvironment = {
    CLOUD: 'CLOUD',
    ON_PREMISE: 'ON_PREMISE',
    NOT_SURE: 'NOT_SURE'
} as const;

export type EmrMethod = 'API' | 'HEALTHJUMP' | 'NONE';

export const EmrMethod = {
    API: 'API',
    HEALTHJUMP: 'HEALTHJUMP',
    NONE: 'NONE'
} as const;

export type HTTPValidationError = {
    detail?: Array<ValidationError>;
};

/**
 * Response for POST /tenants/{tenant_uuid}/rm-v2/mark-invited.
 */
export type MarkInvitedResponse = {
    /**
     * Number of REQUESTED users transitioned to INVITE_SENT.
     */
    usersInvited: number;
    /**
     * True if the tenant has a PROVISIONED event (always true on success).
     */
    provisioned: boolean;
};

export type OktaGetGroupsResponse = {
    groups: Array<OktaGroup>;
};

export type OktaGroup = {
    id: string;
    name: string;
    description: string | null;
};

/**
 * An Okta user record returned by the Okta-users search.
 */
export type OktaUserBase = {
    /**
     * Okta primary email (profile.email).
     */
    email?: string | null;
    /**
     * Okta secondary email (profile.secondEmail).
     */
    secondEmail?: string | null;
    /**
     * Okta user status, e.g. ACTIVE.
     */
    status?: string | null;
    /**
     * Okta login (profile.login).
     */
    login?: string | null;
    /**
     * Best-effort auth method from the Okta credential provider: "SSO" (federated/social) or "Password".
     */
    authMethod?: string | null;
};

export type OktaUserExistence = {
    email: string;
    exists: boolean;
    status?: string | null;
    authMethod?: string | null;
};

export type OktaUsersExistRequest = {
    emails: Array<(string)>;
};

export type OktaUsersExistResponse = {
    users: Array<OktaUserExistence>;
};

/**
 * Model that captures the list of Okta users returned to the client.
 */
export type OktaUsersResponse = {
    /**
     * Matching Okta user records.
     */
    users?: Array<OktaUserBase>;
};

/**
 * Pydantic Model of a OtherEMREntries object.
 */
export type OtherEMREntriesBase = {
    /**
     * The tenant id of the provider that submitted the EMR.
     */
    tenantId: number;
    /**
     * The EMR name for the provider.
     */
    emr: string;
};

/**
 * Pydantic Model of a Permission object.
 */
export type PermissionBase = {
    /**
     * The ID of the Permission
     */
    id: number;
    /**
     * The namespace the permission belongs to.
     */
    namespace: string;
    /**
     * Unique name of the permission used for checking.
     */
    name: string;
    /**
     * Description of what the permissionc ontrols access to.
     */
    description: string;
};

/**
 * Pydantic Model of a ProviderMetadata object.
 */
export type ProviderMetadataBase = {
    /**
     * The roi site ids of the provider.
     */
    roiSiteIds: Array<(number)> | null;
    /**
     * The roi processing site ids of the provider.
     */
    roiProcessingSiteIds: Array<(number)> | null;
    /**
     * The clean site ids of the provider.
     */
    cleanSiteIds: Array<(number)> | null;
    /**
     * The emr site ids of the provider.
     */
    emrSiteIds: Array<(number)> | null;
    /**
     * The data foundations facility ids associated with the provider.
     */
    dataFoundationsFacilityIds: string | null;
    /**
     * The health system ids of child tenants associated with the provider.
     */
    childHealthSystemIds?: Array<(string)> | null;
    /**
     * Whether the tenant is the child of another provider.
     */
    isChildTenant?: boolean | null;
    /**
     * The emr associated with the provider.
     */
    emr?: {
    [key: string]: unknown;
} | null;
};

/**
 * Provider Metadata parameters
 */
export type ProviderMetadataModel = {
    dataFoundationsFacilityIds?: string | null;
    roiProcessingSiteIds?: Array<(number)> | null;
    roiSiteIds?: Array<(number)> | null;
    cleanSiteIds?: Array<(number)> | null;
    emrSiteIds?: Array<(number)> | null;
    emr?: {
    [key: string]: unknown;
} | null;
};

export type QaUserBase = {
    /**
     * The uuid of the User.
     */
    uuid: string;
    /**
     * The first and last name of the User.
     */
    fullName: string;
    /**
     * The email associated with the User.
     */
    email: string;
};

export type QaUsersResponse = {
    /**
     * List of QA users returned to the client.
     */
    users: Array<QaUserBase>;
};

/**
 * Pydantic Model of a RequesterMetadata object.
 */
export type RequesterMetadataBase = {
    /**
     * The lawson ids of the provider.
     */
    lawsonId: number | null;
};

/**
 * Requester Metadata parameters
 */
export type RequesterMetadataModel = {
    lawsonId: number | null;
};

export type ResetOnboardingRequest = {
    email: string;
};

/**
 * Response for POST /users/{user_uuid}/rm-v2/complete.
 */
export type RmV2CompleteResponse = {
    /**
     * The uuid of the user who completed migration.
     */
    userUuid: string;
    /**
     * The user's current RM v2 migration state.
     */
    rmV2MigratedState: string;
};

/**
 * Migration state of a user during the RM v2 (Console) migration.
 */
export type RmV2MigratedState = 'REQUESTED' | 'INVITE_SENT' | 'COMPLETED' | 'PEER_MIGRATED';

/**
 * Migration state of a user during the RM v2 (Console) migration.
 */
export const RmV2MigratedState = {
    REQUESTED: 'REQUESTED',
    INVITE_SENT: 'INVITE_SENT',
    COMPLETED: 'COMPLETED',
    PEER_MIGRATED: 'PEER_MIGRATED'
} as const;

export type RmV2OptInResponse = {
    /**
     * The uuid of the tenant that was opted in.
     */
    tenantUuid: string;
    /**
     * The uuid of the user who triggered opt-in.
     */
    initiatedByUserUuid: string;
    /**
     * Number of users transitioned to REQUESTED.
     */
    usersRequested: number;
    /**
     * Timestamp when the REQUESTED event was first recorded. Null if no users were eligible.
     */
    requestedAt: string | null;
};

/**
 * Pydantic Model of a Tenant object.
 */
export type TenantBase = {
    /**
     * The id of a Tenant.
     */
    id: number | null;
    /**
     * uuid associated with a Tenant.
     */
    tenantUuid: string;
    /**
     * The name of a Tenant.
     */
    tenantName: string | null;
    /**
     * The domains associated with a Tenant.
     */
    domains: Array<(string)> | null;
    /**
     * The types associated with a Tenant.
     */
    tenantTypes: Array<TenantTypes> | null;
    /**
     * The tools associated with a Tenant.
     */
    tools: Array<TenantTools> | null;
    /**
     * The creation date of the Tenant.
     */
    creationDate: string | null;
    /**
     * The updated date of the Tenant.
     */
    updatedDate: string | null;
    /**
     * The parent tenant(s) associated with this user's tenant.
     */
    parentTenants?: Array<TenantBase> | null;
};

/**
 * Represents all data deleted during the tenant offboarding process.
 */
export type TenantOffboardDeletedData = {
    /**
     * List of deleted provider metadata PK IDs.
     */
    providerMetadataDeleted?: Array<(number)> | null;
    /**
     * List of deleted requester metadata PK IDs.
     */
    requesterMetadataDeleted?: Array<(number)> | null;
    /**
     * List of deleted digital metadata PK IDs.
     */
    digitalMetadataDeleted?: Array<(number)> | null;
    /**
     * List of deleted user group PK IDs.
     */
    userGroupsDeleted?: Array<(number)> | null;
    /**
     * List of deleted user group association PK IDs.
     */
    userGroupAssociationsDeleted?: Array<(number)> | null;
    /**
     * List of user IDs that were deleted during offboarding.
     */
    usersDeleted?: Array<(number)> | null;
    /**
     * List of provider verification IDs that were deleted.
     */
    providerVerificationsDeleted?: Array<(number)> | null;
    /**
     * List of phone numbers that were deleted.
     */
    phoneNumbersDeleted?: Array<(string)> | null;
    /**
     * List of fax numbers that were deleted.
     */
    faxNumbersDeleted?: Array<(string)> | null;
    /**
     * List of data coordinate PK IDs that were offboarded in Request Manager.
     */
    rmDataCoordinatesOffboarded?: Array<(number)> | null;
};

/**
 * Rollup migration status for a tenant in the RM v2 (Console) migration.
 */
export type TenantRmV2MigrationStatus = 'NOT_STARTED' | 'IN_PROGRESS' | 'COMPLETED';

/**
 * Rollup migration status for a tenant in the RM v2 (Console) migration.
 */
export const TenantRmV2MigrationStatus = {
    NOT_STARTED: 'NOT_STARTED',
    IN_PROGRESS: 'IN_PROGRESS',
    COMPLETED: 'COMPLETED'
} as const;

/**
 * Response for GET /tenants/{tenant_uuid}/rm-v2/migration-status.
 */
export type TenantRmV2MigrationStatusResponse = {
    /**
     * Rollup migration status for the tenant.
     */
    migrationStatus: TenantRmV2MigrationStatus;
    /**
     * Total number of non-deleted users in the tenant.
     */
    totalUsers: number;
    /**
     * Number of users who have begun migration (non-null state).
     */
    startedUsers: number;
    /**
     * Number of users in COMPLETED state.
     */
    completedUsers: number;
};

export type TenantTools = 'AUDIT_MANAGEMENT_TOOL' | 'MANUAL_UPLOAD_TOOL' | 'RECORD_REQUEST' | 'REQUEST_QUEUE' | 'REQUEST_MANAGER';

export const TenantTools = {
    AUDIT_MANAGEMENT_TOOL: 'AUDIT_MANAGEMENT_TOOL',
    MANUAL_UPLOAD_TOOL: 'MANUAL_UPLOAD_TOOL',
    RECORD_REQUEST: 'RECORD_REQUEST',
    REQUEST_QUEUE: 'REQUEST_QUEUE',
    REQUEST_MANAGER: 'REQUEST_MANAGER'
} as const;

export type TenantTypes = 'LSEPS' | 'ATTORNEY' | 'INTERNAL' | 'PROVIDER' | 'TPO' | 'ONBOARDING';

export const TenantTypes = {
    LSEPS: 'LSEPS',
    ATTORNEY: 'ATTORNEY',
    INTERNAL: 'INTERNAL',
    PROVIDER: 'PROVIDER',
    TPO: 'TPO',
    ONBOARDING: 'ONBOARDING'
} as const;

/**
 * Pydantic Model of a Tenant with its user groups and permissions.
 */
export type TenantWithGroups = {
    /**
     * The id of a Tenant.
     */
    id: number | null;
    /**
     * uuid associated with a Tenant.
     */
    tenantUuid: string;
    /**
     * The name of a Tenant.
     */
    tenantName: string | null;
    /**
     * The domains associated with a Tenant.
     */
    domains: Array<(string)> | null;
    /**
     * The types associated with a Tenant.
     */
    tenantTypes: Array<TenantTypes> | null;
    /**
     * The tools associated with a Tenant.
     */
    tools: Array<TenantTools> | null;
    /**
     * The creation date of the Tenant.
     */
    creationDate: string | null;
    /**
     * The updated date of the Tenant.
     */
    updatedDate: string | null;
    /**
     * The parent tenant(s) associated with this user's tenant.
     */
    parentTenants?: Array<TenantBase> | null;
    /**
     * The user groups associated with this Tenant.
     */
    userGroups: Array<UserGroupPermissions>;
};

export type TenantWithMetadata = {
    /**
     * The id of a Tenant.
     */
    id: number | null;
    /**
     * uuid associated with a Tenant.
     */
    tenantUuid: string;
    /**
     * The name of a Tenant.
     */
    tenantName: string | null;
    /**
     * The domains associated with a Tenant.
     */
    domains: Array<(string)> | null;
    /**
     * The types associated with a Tenant.
     */
    tenantTypes: Array<TenantTypes> | null;
    /**
     * The tools associated with a Tenant.
     */
    tools: Array<TenantTools> | null;
    /**
     * The creation date of the Tenant.
     */
    creationDate: string | null;
    /**
     * The updated date of the Tenant.
     */
    updatedDate: string | null;
    /**
     * The parent tenant(s) associated with this user's tenant.
     */
    parentTenants?: Array<TenantBase> | null;
    /**
     * The provider metatdata of a Tenant.
     */
    providerMetadata: ProviderMetadataBase | null;
    /**
     * The requester metadata of a Tenant.
     */
    requesterMetadata: RequesterMetadataBase | null;
    /**
     * The digital metadata of a Tenant.
     */
    digitalMetadata: DigitalMetadataWithEligibility | null;
};

/**
 * Model that captures the Tenant response sent to the client.
 */
export type TenantsResponse = {
    /**
     * List of tenants returned to the client.
     */
    tenants: Array<TenantBase>;
};

/**
 * Model that captures the Tenants with groups response sent to the client.
 */
export type TenantsWithGroupsResponse = {
    /**
     * List of tenants with user groups returned to the client.
     */
    tenants: Array<TenantWithGroups>;
};

/**
 * Model that captures list Tenant responses with metadata sent to the client.
 */
export type TenantsWithMetadataResponse = {
    /**
     * List of tenants returned to the client.
     */
    tenants: Array<TenantWithMetadata>;
};

/**
 * Digital Metadata parameters
 */
export type UpdateDigitalMetadata = {
    fulfillmentMethod?: string | null;
    isLiveDigitalFulfillment?: boolean | null;
    emr?: string | null;
    emrEnvironment?: string | null;
    onboardingStatus?: DigitalOnboardingStatus | null;
    addressFeedbackComplete?: boolean | null;
    goLiveDate?: string | null;
};

/**
 * Digital Metadata parameters
 */
export type UpdateDigitalMetadataByDigitalSiteId = {
    fulfillmentMethod?: string | null;
    isLiveDigitalFulfillment?: boolean | null;
    emr?: string | null;
    emrEnvironment?: string | null;
    onboardingStatus?: DigitalOnboardingStatus | null;
    addressFeedbackComplete?: boolean | null;
    goLiveDate?: string | null;
};

/**
 * Provider Metadata update parameters
 */
export type UpdateProviderMetadata = {
    dataFoundationsFacilityIds?: string | null;
    roiProcessingSiteIds?: Array<(number)> | null;
    roiSiteIds?: Array<(number)> | null;
    cleanSiteIds?: Array<(number)> | null;
    emrSiteIds?: Array<(number)> | null;
    emr?: {
    [key: string]: unknown;
} | null;
};

export type UpdateRequesterMetadata = {
    lawsonId?: number | null;
};

/**
 * The parameters a caller can use to edit a Tenant.
 */
export type UpdateTenant = {
    tenantName?: string | null;
    domains?: Array<(string)> | null;
    tenantTypes?: Array<(string)> | null;
    tools?: Array<(string)> | null;
    providerMetadata?: UpdateProviderMetadata | null;
    requesterMetadata?: UpdateRequesterMetadata | null;
    digitalMetadata?: UpdateDigitalMetadata | null;
    deleted?: boolean | null;
};

/**
 * The parameters a caller can use to update a User.
 */
export type UpdateUser = {
    tenantId?: number | null;
    firstName?: string | null;
    lastName?: string | null;
    emailAddress?: string | null;
    isAdmin?: boolean | null;
    termsAccepted?: boolean | null;
    termsAcceptedV2?: boolean | null;
    deleted?: boolean | null;
    lastLoginTime?: string | null;
};

/**
 * Request model for adding or removing a user group.
 */
export type UpdateUserGroupRequest = {
    /**
     * Action to perform: 'add' or 'remove'.
     */
    action: UserGroupAction;
    /**
     * ID of the user group to add or remove.
     */
    userGroupId: number;
};

/**
 * The parameters a caller can use to update Users.
 */
export type UpdateUsers = {
    users: Array<UpdateUser>;
};

/**
 * Pydantic Model of a User Alias object.
 */
export type UserAliasBase = {
    /**
     * The ID of the User Alias.
     */
    id: number;
    /**
     * The tenant_user.user_id this alias refers to.
     */
    userId: number;
    /**
     * The alias email associated with the user
     */
    aliasEmail: string;
};

/**
 * Pydantic Model of a User Object.
 */
export type UserBase = {
    /**
     * The uuid of the User.
     */
    userUuid: string | null;
    /**
     * The id of the User.
     */
    id: number | null;
    /**
     * The first name of the User.
     */
    firstName: string | null;
    /**
     * The last name of the User.
     */
    lastName: string | null;
    /**
     * The email associated with the User.
     */
    emailAddress: string | null;
    /**
     * This specifies if a user is an admin or not.
     */
    isAdmin: boolean;
    /**
     * The id of the tenant that the user belongs with.
     */
    tenantId: number | null;
    /**
     * The dictionary representing the tenant that the user belongs to.
     */
    tenant: TenantBase | null;
    /**
     * This specifies if a user has agreed to the terms of service or not.
     */
    termsAccepted: boolean;
    /**
     * This specifies if a user has agreed to the v2 terms of service or not.
     */
    termsAcceptedV2: boolean;
    /**
     * The parent tenant(s) associated with this user's tenant.
     */
    parentTenants?: Array<TenantBase> | null;
    /**
     * List of permissions the user has.
     */
    permissions: Array<PermissionBase>;
    /**
     * List of user groups the user belongs to.
     */
    userGroups: Array<UserGroupBase>;
    /**
     * List of user's aliases.
     */
    userAliases: Array<UserAliasBase>;
    /**
     * Whether the user is a Datavanter. Read-only, set directly in the database.
     */
    isDatavanter: boolean;
    /**
     * The last time the user logged into a system. Not all applications update this for a user.
     */
    lastLoginTime: string | null;
    /**
     * Migration state of the user during the RM v2 (Console) migration.
     */
    rmV2MigratedState?: RmV2MigratedState | null;
};

/**
 * Enum for user group actions.
 */
export type UserGroupAction = 'add' | 'remove';

/**
 * Enum for user group actions.
 */
export const UserGroupAction = {
    ADD: 'add',
    REMOVE: 'remove'
} as const;

/**
 * Pydantic Model of a User Group object.
 */
export type UserGroupBase = {
    /**
     * The ID of the User Group.
     */
    id: number;
    /**
     * The display name of the user group.
     */
    displayName: string;
    /**
     * The unique identifier of the type of user grouping this is.
     */
    type: string;
};

/**
 * Pydantic Model of a User Group object with associated permissions.
 */
export type UserGroupPermissions = {
    /**
     * The ID of the User Group.
     */
    id: number;
    /**
     * The display name of the user group.
     */
    displayName: string;
    /**
     * The unique identifier of the type of user grouping this is.
     */
    type: string;
    /**
     * List of permissions associated with this user group.
     */
    permissions: Array<PermissionBase>;
};

/**
 * Model that captures the list of User Group including associated permissions response sent to the client.
 */
export type UserGroupsPermissionsResponse = {
    /**
     * List of user groups including associated permissions returned to the client.
     */
    userGroups: Array<UserGroupPermissions>;
};

/**
 * Model that captures the list of User Group response sent to the client.
 */
export type UserGroupsResponse = {
    /**
     * List of user groups returned to the client.
     */
    userGroups: Array<UserGroupBase>;
};

/**
 * Model that captures the User response sent to the client.
 */
export type UserResponse = {
    /**
     * User returned to the client.
     */
    user: UserBase;
};

export type UserRoleLookupItem = {
    userUuid: string;
};

export type UserRolesEntry = {
    userUuid: string;
    roleIds: Array<(number)>;
};

export type UserRolesLookupRequest = {
    users: Array<UserRoleLookupItem>;
};

export type UserRolesLookupResponse = {
    users: Array<UserRolesEntry>;
};

/**
 * Total number of users matching a query — companion to the paginated /users/all list.
 */
export type UsersCountResponse = {
    /**
     * Total number of users matching the query, across all pages.
     */
    total: number;
};

/**
 * Model that captures the list of User response sent to the client.
 */
export type UsersResponse = {
    /**
     * List of users returned to the client.
     */
    users: Array<UserBase>;
};

export type ValidationError = {
    loc: Array<(string | number)>;
    msg: string;
    type: string;
    input?: unknown;
    ctx?: {
        [key: string]: unknown;
    };
};

export type HealthHealthGetResponse = unknown;

export type InfoInfoGetResponse = unknown;

export type CreateNewUserUsersPostData = {
    requestBody: CreateUser;
};

export type CreateNewUserUsersPostResponse = UserResponse;

export type ListUsersUsersGetData = {
    email?: string | null;
    emailList?: Array<(string)> | null;
    includeDeleted?: boolean | null;
    tenantUuid?: string | null;
};

export type ListUsersUsersGetResponse = UsersResponse;

export type EditUserUsersUserUuidPatchData = {
    includeDeleted?: boolean | null;
    requestBody: UpdateUser;
    userUuid: string;
};

export type EditUserUsersUserUuidPatchResponse = UserResponse;

export type GetUserByUuidUsersUserUuidGetData = {
    userUuid: string;
};

export type GetUserByUuidUsersUserUuidGetResponse = UserResponse;

export type DeleteUserByUuidUsersUserUuidDeleteData = {
    userUuid: string;
};

export type DeleteUserByUuidUsersUserUuidDeleteResponse = void;

export type CreateNewUsersUsersBatchCreatePostData = {
    requestBody: CreateUsers;
};

export type CreateNewUsersUsersBatchCreatePostResponse = UsersResponse;

export type UpdateUsersUsersBatchUpdatePostData = {
    includeDeleted?: boolean | null;
    requestBody: UpdateUsers;
};

export type UpdateUsersUsersBatchUpdatePostResponse = UsersResponse;

export type GetAllUsersForAllTenantsUsersBasicInfoGetData = {
    limit?: number | null;
    offset?: number | null;
    tools?: string | null;
};

export type GetAllUsersForAllTenantsUsersBasicInfoGetResponse = {
    [key: string]: Array<UserBase>;
};

export type ListAllUsersUsersAllGetData = {
    limit?: number | null;
    offset?: number | null;
    search?: string | null;
};

export type ListAllUsersUsersAllGetResponse = UsersResponse;

export type ListAllUsersCountUsersAllCountGetData = {
    search?: string | null;
};

export type ListAllUsersCountUsersAllCountGetResponse = UsersCountResponse;

export type GetQaUsersUsersQaGetResponse = QaUsersResponse;

export type GetOktaGroupsUsersOktaGroupsGetResponse = OktaGetGroupsResponse;

export type OktaUserExistsUsersOktaUserExistsGetData = {
    email: string;
};

export type OktaUserExistsUsersOktaUserExistsGetResponse = unknown;

export type OktaUsersExistUsersOktaUsersExistPostData = {
    requestBody: OktaUsersExistRequest;
};

export type OktaUsersExistUsersOktaUsersExistPostResponse = OktaUsersExistResponse;

export type ListOktaUsersUsersOktaUsersGetData = {
    email: string;
};

export type ListOktaUsersUsersOktaUsersGetResponse = OktaUsersResponse;

export type GetUserGroupsByTenantUsersUserGroupsGetData = {
    tenantUuid: string;
};

export type GetUserGroupsByTenantUsersUserGroupsGetResponse = UserGroupsResponse;

export type GetUserGroupsAndPermissionsByTenantUsersUserGroupsPermissionsGetData = {
    tenantUuid: string;
};

export type GetUserGroupsAndPermissionsByTenantUsersUserGroupsPermissionsGetResponse = UserGroupsPermissionsResponse;

export type GetUserOktaGroupsUsersUserUuidOktaGroupsGetData = {
    userUuid: string;
};

export type GetUserOktaGroupsUsersUserUuidOktaGroupsGetResponse = OktaGetGroupsResponse;

export type LookupUserRolesUsersRolesPostData = {
    requestBody: UserRolesLookupRequest;
};

export type LookupUserRolesUsersRolesPostResponse = UserRolesLookupResponse;

export type UpdateUserGroupUsersUserUuidUserGroupsPostData = {
    requestBody: UpdateUserGroupRequest;
    userUuid: string;
};

export type UpdateUserGroupUsersUserUuidUserGroupsPostResponse = UserResponse;

export type ResetUserToOnboardingByEmailUsersResetOnboardingPostData = {
    requestBody: ResetOnboardingRequest;
};

export type ResetUserToOnboardingByEmailUsersResetOnboardingPostResponse = UserResponse;

export type RmV2OptInUsersUserUuidRmV2OptInPostData = {
    userUuid: string;
};

export type RmV2OptInUsersUserUuidRmV2OptInPostResponse = RmV2OptInResponse;

export type RmV2CompleteUsersUserUuidRmV2CompletePostData = {
    userUuid: string;
};

export type RmV2CompleteUsersUserUuidRmV2CompletePostResponse = RmV2CompleteResponse;

export type ResetLastLoginUsersUserUuidResetLastLoginPostData = {
    userUuid: string;
};

export type ResetLastLoginUsersUserUuidResetLastLoginPostResponse = UserResponse;

export type SendActivationEmailUsersUserUuidSendActivationEmailPostData = {
    requestBody?: Body_send_activation_email_users__user_uuid__send_activation_email_post;
    userUuid: string;
};

export type SendActivationEmailUsersUserUuidSendActivationEmailPostResponse = UserResponse;

export type ResendActivationEmailUsersUserUuidResendActivationEmailPostData = {
    requestBody?: Body_resend_activation_email_users__user_uuid__resend_activation_email_post;
    userUuid: string;
};

export type ResendActivationEmailUsersUserUuidResendActivationEmailPostResponse = UserResponse;

export type ResetPasswordUsersUserUuidResetPasswordPostData = {
    requestBody?: Body_reset_password_users__user_uuid__reset_password_post;
    userUuid: string;
};

export type ResetPasswordUsersUserUuidResetPasswordPostResponse = UserResponse;

export type ListTenantsTenantsGetData = {
    tenantTypes?: Array<TenantTypes> | null;
};

export type ListTenantsTenantsGetResponse = TenantsResponse;

export type CreateNewTenantTenantsPostData = {
    requestBody: CreateTenant;
};

export type CreateNewTenantTenantsPostResponse = TenantWithMetadata;

export type ListTenantsWithGroupsTenantsWithGroupsGetData = {
    tenantTypes?: Array<TenantTypes> | null;
};

export type ListTenantsWithGroupsTenantsWithGroupsGetResponse = TenantsWithGroupsResponse;

export type SearchTenantsTenantsSearchGetData = {
    tenantName?: string | null;
    tenantTypes?: Array<TenantTypes> | null;
    tenantUuid?: string | null;
};

export type SearchTenantsTenantsSearchGetResponse = TenantsResponse;

export type GetDigitalEmrEligibilityTenantsDigitalEmrEligibilityGetResponse = Array<EligibilityBase>;

export type ListDfTenantsTenantsDigitalFulfillmentTenantsGetResponse = TenantsWithMetadataResponse;

export type CreateOtherEmrEntryTenantsOtherEmrPostData = {
    requestBody: OtherEMREntriesBase;
};

export type CreateOtherEmrEntryTenantsOtherEmrPostResponse = OtherEMREntriesBase;

export type GetTenantByTenantUuidTenantsTenantUuidGetData = {
    tenantUuid: string;
};

export type GetTenantByTenantUuidTenantsTenantUuidGetResponse = TenantWithMetadata;

export type DeleteTenantTenantsTenantUuidDeleteData = {
    tenantUuid: string;
};

export type DeleteTenantTenantsTenantUuidDeleteResponse = void;

export type EditTenantTenantsTenantUuidPatchData = {
    includeDeleted?: boolean;
    requestBody: UpdateTenant;
    tenantUuid: string;
};

export type EditTenantTenantsTenantUuidPatchResponse = TenantWithMetadata;

export type GetTenantByDigitalSiteIdTenantsDigitalSiteIdDigitalSiteIdGetData = {
    digitalSiteId: number;
};

export type GetTenantByDigitalSiteIdTenantsDigitalSiteIdDigitalSiteIdGetResponse = TenantWithMetadata;

export type GetTenantByHealthSystemIdTenantsHealthSystemHealthSystemIdGetData = {
    healthSystemId: string;
};

export type GetTenantByHealthSystemIdTenantsHealthSystemHealthSystemIdGetResponse = TenantWithMetadata;

export type EditTenantByHealthSystemIdTenantsHealthSystemHealthSystemIdPatchData = {
    healthSystemId: string;
    requestBody: UpdateTenant;
};

export type EditTenantByHealthSystemIdTenantsHealthSystemHealthSystemIdPatchResponse = TenantWithMetadata;

export type EditDigitalMetadataByDigitalSiteIdTenantsDfDigitalSiteIdPatchData = {
    digitalSiteId: number;
    requestBody: UpdateDigitalMetadataByDigitalSiteId;
};

export type EditDigitalMetadataByDigitalSiteIdTenantsDfDigitalSiteIdPatchResponse = TenantWithMetadata;

export type SendContractTenantsDfAutofulfillContractPostData = {
    emails: string;
};

export type SendContractTenantsDfAutofulfillContractPostResponse = unknown;

export type OffboardTenantTenantsTenantUuidOffboardPostData = {
    /**
     * Boolean to indicate if the tenant has a significant number of requests -- if so, then do not offboard
     */
    checkSignificantRequestsVolume?: boolean;
    /**
     * Boolean to indicate if all Data Foundation feedback associated with the tenant should be deleted
     */
    deleteDfFeedback?: boolean;
    /**
     * Boolean to indicate if users associated with the tenant should be deleted
     */
    deleteUsers?: boolean;
    tenantUuid: string;
};

export type OffboardTenantTenantsTenantUuidOffboardPostResponse = TenantOffboardDeletedData;

export type MarkInvitedTenantsTenantUuidRmV2MarkInvitedPostData = {
    tenantUuid: string;
};

export type MarkInvitedTenantsTenantUuidRmV2MarkInvitedPostResponse = MarkInvitedResponse;

export type GetRmV2MigrationStatusTenantsTenantUuidRmV2MigrationStatusGetData = {
    tenantUuid: string;
};

export type GetRmV2MigrationStatusTenantsTenantUuidRmV2MigrationStatusGetResponse = TenantRmV2MigrationStatusResponse;

export type $OpenApiTs = {
    '/health': {
        get: {
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
            };
        };
    };
    '/info': {
        get: {
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
            };
        };
    };
    '/users': {
        post: {
            req: CreateNewUserUsersPostData;
            res: {
                /**
                 * Successful Response
                 */
                201: UserResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
        get: {
            req: ListUsersUsersGetData;
            res: {
                /**
                 * Successful Response
                 */
                200: UsersResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/users/{user_uuid}': {
        patch: {
            req: EditUserUsersUserUuidPatchData;
            res: {
                /**
                 * Successful Response
                 */
                200: UserResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
        get: {
            req: GetUserByUuidUsersUserUuidGetData;
            res: {
                /**
                 * Successful Response
                 */
                200: UserResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
        delete: {
            req: DeleteUserByUuidUsersUserUuidDeleteData;
            res: {
                /**
                 * Successful Response
                 */
                204: void;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/users/batch-create': {
        post: {
            req: CreateNewUsersUsersBatchCreatePostData;
            res: {
                /**
                 * Successful Response
                 */
                201: UsersResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/users/batch-update': {
        post: {
            req: UpdateUsersUsersBatchUpdatePostData;
            res: {
                /**
                 * Successful Response
                 */
                200: UsersResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/users/basic-info': {
        get: {
            req: GetAllUsersForAllTenantsUsersBasicInfoGetData;
            res: {
                /**
                 * Successful Response
                 */
                200: {
                    [key: string]: Array<UserBase>;
                };
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/users/all': {
        get: {
            req: ListAllUsersUsersAllGetData;
            res: {
                /**
                 * Successful Response
                 */
                200: UsersResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/users/all/count': {
        get: {
            req: ListAllUsersCountUsersAllCountGetData;
            res: {
                /**
                 * Successful Response
                 */
                200: UsersCountResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/users/qa': {
        get: {
            res: {
                /**
                 * Successful Response
                 */
                200: QaUsersResponse;
            };
        };
    };
    '/users/okta_groups': {
        get: {
            res: {
                /**
                 * Successful Response
                 */
                200: OktaGetGroupsResponse;
            };
        };
    };
    '/users/okta_user_exists': {
        get: {
            req: OktaUserExistsUsersOktaUserExistsGetData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/users/okta_users_exist': {
        post: {
            req: OktaUsersExistUsersOktaUsersExistPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: OktaUsersExistResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/users/okta-users': {
        get: {
            req: ListOktaUsersUsersOktaUsersGetData;
            res: {
                /**
                 * Successful Response
                 */
                200: OktaUsersResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/users/user_groups': {
        get: {
            req: GetUserGroupsByTenantUsersUserGroupsGetData;
            res: {
                /**
                 * Successful Response
                 */
                200: UserGroupsResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/users/user_groups/permissions': {
        get: {
            req: GetUserGroupsAndPermissionsByTenantUsersUserGroupsPermissionsGetData;
            res: {
                /**
                 * Successful Response
                 */
                200: UserGroupsPermissionsResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/users/{user_uuid}/okta_groups': {
        get: {
            req: GetUserOktaGroupsUsersUserUuidOktaGroupsGetData;
            res: {
                /**
                 * Successful Response
                 */
                200: OktaGetGroupsResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/users/roles': {
        post: {
            req: LookupUserRolesUsersRolesPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: UserRolesLookupResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/users/{user_uuid}/user_groups': {
        post: {
            req: UpdateUserGroupUsersUserUuidUserGroupsPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: UserResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/users/reset-onboarding': {
        post: {
            req: ResetUserToOnboardingByEmailUsersResetOnboardingPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: UserResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/users/{user_uuid}/rm-v2/opt-in': {
        post: {
            req: RmV2OptInUsersUserUuidRmV2OptInPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: RmV2OptInResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/users/{user_uuid}/rm-v2/complete': {
        post: {
            req: RmV2CompleteUsersUserUuidRmV2CompletePostData;
            res: {
                /**
                 * Successful Response
                 */
                200: RmV2CompleteResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/users/{user_uuid}/reset_last_login': {
        post: {
            req: ResetLastLoginUsersUserUuidResetLastLoginPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: UserResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/users/{user_uuid}/send_activation_email': {
        post: {
            req: SendActivationEmailUsersUserUuidSendActivationEmailPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: UserResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/users/{user_uuid}/resend_activation_email': {
        post: {
            req: ResendActivationEmailUsersUserUuidResendActivationEmailPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: UserResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/users/{user_uuid}/reset_password': {
        post: {
            req: ResetPasswordUsersUserUuidResetPasswordPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: UserResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/tenants': {
        get: {
            req: ListTenantsTenantsGetData;
            res: {
                /**
                 * Successful Response
                 */
                200: TenantsResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
        post: {
            req: CreateNewTenantTenantsPostData;
            res: {
                /**
                 * Successful Response
                 */
                201: TenantWithMetadata;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/tenants/with-groups': {
        get: {
            req: ListTenantsWithGroupsTenantsWithGroupsGetData;
            res: {
                /**
                 * Successful Response
                 */
                200: TenantsWithGroupsResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/tenants/search': {
        get: {
            req: SearchTenantsTenantsSearchGetData;
            res: {
                /**
                 * Successful Response
                 */
                200: TenantsResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/tenants/digital-emr-eligibility': {
        get: {
            res: {
                /**
                 * Successful Response
                 */
                200: Array<EligibilityBase>;
            };
        };
    };
    '/tenants/digital-fulfillment-tenants': {
        get: {
            res: {
                /**
                 * Successful Response
                 */
                200: TenantsWithMetadataResponse;
            };
        };
    };
    '/tenants/other-emr': {
        post: {
            req: CreateOtherEmrEntryTenantsOtherEmrPostData;
            res: {
                /**
                 * Successful Response
                 */
                201: OtherEMREntriesBase;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/tenants/{tenant_uuid}': {
        get: {
            req: GetTenantByTenantUuidTenantsTenantUuidGetData;
            res: {
                /**
                 * Successful Response
                 */
                200: TenantWithMetadata;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
        delete: {
            req: DeleteTenantTenantsTenantUuidDeleteData;
            res: {
                /**
                 * Successful Response
                 */
                204: void;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
        patch: {
            req: EditTenantTenantsTenantUuidPatchData;
            res: {
                /**
                 * Successful Response
                 */
                200: TenantWithMetadata;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/tenants/digital-site-id/{digital_site_id}': {
        get: {
            req: GetTenantByDigitalSiteIdTenantsDigitalSiteIdDigitalSiteIdGetData;
            res: {
                /**
                 * Successful Response
                 */
                200: TenantWithMetadata;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/tenants/health-system/{health_system_id}': {
        get: {
            req: GetTenantByHealthSystemIdTenantsHealthSystemHealthSystemIdGetData;
            res: {
                /**
                 * Successful Response
                 */
                200: TenantWithMetadata;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
        patch: {
            req: EditTenantByHealthSystemIdTenantsHealthSystemHealthSystemIdPatchData;
            res: {
                /**
                 * Successful Response
                 */
                200: TenantWithMetadata;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/tenants/df/{digital_site_id}': {
        patch: {
            req: EditDigitalMetadataByDigitalSiteIdTenantsDfDigitalSiteIdPatchData;
            res: {
                /**
                 * Successful Response
                 */
                200: TenantWithMetadata;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/tenants/df/autofulfill-contract': {
        post: {
            req: SendContractTenantsDfAutofulfillContractPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: unknown;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/tenants/{tenant_uuid}/offboard': {
        post: {
            req: OffboardTenantTenantsTenantUuidOffboardPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: TenantOffboardDeletedData;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/tenants/{tenant_uuid}/rm-v2/mark-invited': {
        post: {
            req: MarkInvitedTenantsTenantUuidRmV2MarkInvitedPostData;
            res: {
                /**
                 * Successful Response
                 */
                200: MarkInvitedResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
    '/tenants/{tenant_uuid}/rm-v2/migration-status': {
        get: {
            req: GetRmV2MigrationStatusTenantsTenantUuidRmV2MigrationStatusGetData;
            res: {
                /**
                 * Successful Response
                 */
                200: TenantRmV2MigrationStatusResponse;
                /**
                 * Validation Error
                 */
                422: HTTPValidationError;
            };
        };
    };
};